module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-wp.jpg?v=a9fa550a";